/*
 * @Description: new file
 * @Autor: qyy
 * @Date: 2023-02-24 11:25:53
 * @LastEditors: qyy
 * @LastEditTime: 2023-02-24 16:10:11
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
import Vue from 'vue'
// import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import dataV from '@jiaminghi/data-view'
import echarts from 'echarts'
import VueCookies from 'vue-cookies'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.less'

// Vue.prototype.$eventBus = new Vue()
/* eslint-disable no-new */
import defined from './js/defined.js'

Vue.use(VueCookies)
Vue.use(ElementUI)
Vue.use(dataV)

const url = VueCookies.get('requestUrl')
// axios.defaults.baseURL = 'http://bsmtp:8080'
axios.defaults.baseURL =""// url || 'http://47.107.138.238/bsmtp/public'
// 超时时间
axios.default.timeout = 100 * 1000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
// 请求拦截器 params加入compid
// axios.interceptors.request.use(function (config) {
//   config.params = {
//     ...config.params,
//     compid: VueCookies.get('bsmcompid')
//   }
//   return config
// }, function (err) {
//   // 处理响应的错误信息
//   console.log(err)
// })

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$echarts = echarts

Vue.prototype.compid = -1
Vue.prototype.dept = ''
Vue.prototype.userpower = 0
Vue.prototype.powerstr = ''
Vue.prototype.userinfo = []
// Vue.config.globalProperties.copid=0;

// Vue.prototype.api=process.env.NODEV_ENV==='production'?'':'/api'
Vue.use(VueAxios, axios)
Vue.config.productionTip = false
Vue.prototype.api = process.env.NODE_ENV === 'production' ? '' : '/api'// 引用文件
Vue.prototype.defined = defined// 挂载到Vue实例上面

new Vue({
  el: '#app',
  router,
  beforeCreate () {
    Vue.prototype.$eventBus = this // 事件总线
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js